<template>
    <div>
        <!-- <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <h3>Reporte de Arriendos de Camiones</h3>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="tableFixHead" style="width:100%" v-show="data.length > 0">
                        <table class="table table-bordered">
                            <thead class="thead-skyblue2">
                                <tr>
                                    <th class="fixed background-salmon-1">PATENTE</th>
                                    <th class="fixed background-salmon-1">EMPRESA</th>
                                    <th class="fixed background-salmon-1">VIGENTE DESDE</th>
                                    <th class="fixed background-salmon-1">VIGENTE HASTA</th>
                                    <th class="fixed background-salmon-1">TARIFA ARRIENDO</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="d in data" :key="d.fecha">
                                    <td>{{ d.patente }}</td>
                                    <td>{{ d.nombre }}</td>
                                    <td>{{ d.vigente_desde | fecha }}</td>
                                    <td>{{ d.vigente_hasta | fecha }}</td>
                                    <td>{{ d.valor | formatear_miles }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div> -->



        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <h2>GRÁFICOS DE ARRIENDO POR PERIODO</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <h4>Selección Patente</h4>
                        <v-select class="" v-model="transportes_id" :closeOnSelect="false" :options="camiones_arrendados"
                            label="patente" multiple @input="arriendo_por_periodo">
                            <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    No se Encontraron Resultados Para
                                    <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                            </template>
                        </v-select>
                    </div>
                    <div class="col text-right">
                        <button class="btn btn-success btn-icon" @click="descargar_excel_arriendo">
                            <i class="fas fa-file-excel"></i> Excel
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <!-- <canvas id="arriendo_por_periodo"></canvas> -->
                    </div>
                    <div class="col">


                    </div>
                </div>
                <div class="spinner-3 mt-8" v-show="spinner_arriendo"></div>
                <div class="row mx-auto mt-4" style="width: 80%;">
                    <canvas id="arriendo_por_periodo"></canvas>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <h2>GRÁFICOS DETALLE POR CAMION </h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <h4>Selección Patente</h4>
                        <v-select class="" v-model="transportes_ids_completo" :closeOnSelect="false"
                            :options="camiones_petroleo" label="patente" multiple>
                            <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    No se Encontraron Resultados Para
                                    <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                            </template>
                        </v-select>
                        
                    </div>
                    <div class="col text-right">
                        <button class="btn btn-success btn-icon" :disabled="transportes_ids_completo.length == 0"
                            @click="camion_por_periodo">Filtrar
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <p>Pinche en el boton correspondiente para ver los gráficos de la patente</p>
                    </div>
                </div>
                <div class="row my-2">
                    <div class="col">
                        <button
                            type="button"
                            class="btn btn-primary"
                            v-for="camion in data_detalle_camion"
                            :key="camion.id"
                            @click="toggleButtonColor(camion), renderChartCamion(camion)"
                            :class="{ 'selected-button': isSelected(camion) }"
                            >
                            {{ camion.patente }} <span class="badge badge-default"><i class="fas fa-truck"></i></span>
                        </button>


                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <!-- <canvas id="arriendo_por_periodo"></canvas> -->
                    </div>
                    <div class="col">


                    </div>
                </div>
                <!-- <div class="row">
                    <canvas id="grafico_detalle_camion"></canvas>
                </div> -->
                
                <div class="spinner-3 mt-4" v-show="spinner_detalle"></div>
                <div class="row">
                    <div class="col" style="width: 50%;">
                        <canvas id="grafico_kilometrajes"></canvas>
                    </div>

                    <div class="col" style="width: 50%;">
                        <canvas id="grafico_rendimiento"></canvas>
                    </div>
                </div>

                <div class="row mx-auto mt-4" style="width: 50%;">
                    <div class="col">
                        <canvas id="grafico_petroleo"></canvas>
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <h2>GRÁFICOS DE CONSUMO Y CARGA DE PETROLEO POR PERIODO</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <h4>Periodo</h4>
                        <v-select class="" v-model="periodos" :closeOnSelect="false" :options="periodos_petroleo"
                            label="periodo" multiple @input="petroleo_por_periodo">
                            <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    No se Encontraron Resultados Para
                                    <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="spinner-3 mt-8" v-show="spinner_petroleo"></div>
                <div class="row mx-auto mt-4" style="width: 80%;">
                    <div class="col">
                        <canvas id="petroleo_por_periodo"></canvas>
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <h2>GRÁFICOS DE RECEPCIÓN DE SUBPRODUCTO POR PERIODO</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <h4>Selección Periodo</h4>
                        <v-select class="" v-model="periodos_mensuales_select" :closeOnSelect="false"
                            :options="periodos_mensuales" label="periodo" multiple @input="desecho_por_periodo">
                            <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    No se Encontraron Resultados Para
                                    <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                            </template>
                        </v-select>
                    </div>
                    <div class="col"></div>
                </div>
                <div class="row">
                    <div class="col mx-auto mt-4" style="width: 50%;">
                        <!-- <canvas id="arriendo_por_periodo"></canvas> -->
                    </div>
                    <div class="col">


                    </div>
                </div>
                <div class="spinner-3 mt-8" v-show="spinner_desecho"></div>
                <div class="row mx-auto mt-4" style="width: 80%;">
                    <canvas id="desecho_por_periodo"></canvas>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <h2>GRÁFICOS DE RECEPCIÓN DE MORTALIDAD/ENSILAJE POR PERIODO</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <h4>Selección Periodo</h4>
                        <v-select class="" v-model="periodos_mensuales_select" :closeOnSelect="false"
                            :options="periodos_mensuales" label="periodo" multiple @input="desecho_por_periodo">
                            <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    No se Encontraron Resultados Para
                                    <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                            </template>
                        </v-select>
                    </div>
                    <div class="col"></div>
                </div>
                <div class="row">
                    <div class="col">
                        <!-- <canvas id="arriendo_por_periodo"></canvas> -->
                    </div>
                    <div class="col">


                    </div>
                </div>
                <div class="spinner-3 mt-8" v-show="spinner_mortalidad"></div>
                <div class="row mx-auto mt-4" style="width: 80%;">
                    <canvas id="mortalidad_ensilaje_por_periodo"></canvas>
                </div>
            </div>
        </div>

        <!-- <pre>{{ periodos_petroleo }}</pre>
        <pre>{{ camiones_arrendados }}</pre> -->
    </div>
</template>
<script>
import { mapState } from 'vuex';
import Chart from 'chart.js/auto';

export default {
    data: () => ({
        fecha: null,
        data: [],
        bar_chart_petroleo: null,
        bar_chart_arriendo: null,
        chart_desecho: null,
        chart_mortalidad_ensilaje: null,
        chart_detalle_camion:null,
        chart_detalle_kilometraje:null,
        chart_detalle_rendimiento:null,
        chart_detalle_petroleo:null,
        periodos_petroleo: [],
        periodos: [],
        camiones_arrendados: [],
        camiones_petroleo: [],
        periodos_mensuales: [],
        periodos_mensuales_select: [],
        transportes_id: [],
        transportes_ids_completo: [],
        url_excel_arriendo: null,
        data_detalle_camion:[],
        selectedButtons: [],
        selectedButtonId: null,
        spinner_arriendo: false,
        spinner_detalle: false,
        spinner_petroleo: false,
        spinner_desecho: false,
        spinner_mortalidad: false
    }),
    async mounted() {
        // this.spinner = true;
        this.fecha = this.$moment().format('YYYY-MM-DD')
        //this.cargar()
        //console.log(this.fecha)
        //this.renderBarChart()
        await this.cargar_camiones_arrendados()
        await this.cargar_camiones_petroleo()
        this.calcular_periodos()
        this.petroleo_por_periodo()
        this.arriendo_por_periodo()
        await this.calcular_periodos_mensuales()
        await this.desecho_por_periodo()
        await this.mortalidad_ensilaje_por_periodo()
        // await this.camion_por_periodo()
    },
    methods: {
        toggleButtonColor(camion) {
            if (this.selectedButtonId === camion.id) {
                // Clicked the currently selected button, so deselect it
                this.selectedButtonId = null;
            } else {
                // Clicked a different button, so select it
                this.selectedButtonId = camion.id;
            }
            },
            isSelected(camion) {
            return this.selectedButtonId === camion.id;
        },

        calcular_periodos() {
            let current = this.$moment().add(1, 'month')
            let mutable = this.$moment().add(1, 'month')
            let current_year = this.$moment().add(1, 'month').year()
            let id = 1
            while (current_year == current.year()) {
                mutable = mutable.subtract(1, 'month')
                this.periodos_petroleo.push({
                    desde: `26-${mutable.format("MM")}-${mutable.format("YYYY")}`,
                    periodo: `26-${mutable.format("MM")}-${mutable.format("YYYY")} / 25-${current.format("MM")}-${current.format("YYYY")}`,
                    hasta: `25-${current.format("MM")}-${current.format("YYYY")}`,
                    from: `${mutable.format("YYYY")}-${mutable.format("MM")}-26 00:00:00`,
                    to: `${current.format("YYYY")}-${current.format("MM")}-25 23:59:59`
                })
                id++
                //console.log(`from: ${mutable.format("YYYY")}-${mutable.format("MM")}-26 | to:${current.format("YYYY")}-${current.format("MM")}-25`)
                current = current.subtract(1, 'month')
                //console.log(`${current.format("DD-MM-YYYY")}`)
            }
            this.periodos_petroleo = this.periodos_petroleo.reverse()
        },

        calcular_periodos_mensuales() {
            let current = this.$moment()
            let current_year = this.$moment().year()
            while (current_year == current.year()) {
                this.periodos_mensuales.push({
                    desde: current.startOf('month').format('DD-MM-YYYY'),
                    hasta: current.endOf('month').format('DD-MM-YYYY'),
                    from: current.startOf('month').format('YYYY-MM-DD 00:00:00'),
                    to: current.endOf('month').format('YYYY-MM-DD 23:59:59'),
                    periodo: `${current.startOf('month').format('DD-MM-YYYY')} / ${current.endOf('month').format('DD-MM-YYYY')}`
                })
                current = current.subtract(1, 'month')
            }
            this.periodos_mensuales = this.periodos_mensuales.reverse()
        },

        async petroleo_por_periodo() {
            this.spinner_petroleo = true;
            let body = {
                periodos: this.periodos.length == 0 ? this.periodos_petroleo : this.periodos
            }
            await this.axios.post(`${this.api}/reporte/grafico/petroleo_por_periodo`, body, this.cabeceras_json).then(r => {
                console.log('dataaaa', r.data)
                this.renderBarChartPetroleo(r.data)
            })
            this.spinner_petroleo = false;
        },

        async camion_por_periodo() {
            this.spinner_detalle = true;
            let body = {
                periodos: this.periodos.length == 0 ? this.periodos_petroleo : this.periodos,
                camiones: this.transportes_ids_completo
            }
            await this.axios.post(`${this.api}/reporte/grafico/camion_por_periodo`, body, this.cabeceras_json).then(r => {
                console.log('dataaaa camion', r.data)
                this.data_detalle_camion = r.data
                this.renderChartCamion(this.data_detalle_camion[0])

                //this.renderBarChartPetroleo(r.data)
            })
            this.spinner_detalle = false;
        },

        async arriendo_por_periodo() {
            this.spinner_arriendo = true;
            let body = {
                camiones: this.transportes_id.length == 0 ? this.camiones_arrendados : this.transportes_id,
                periodos: this.periodos_petroleo
            }
            await this.axios.post(`${this.api}/reporte/grafico/arriendo_por_periodo`, body, this.cabeceras_json).then(r => {
                console.log('dataaaa', r.data)
                this.renderBarChartArriendo(r.data)
                this.url_excel_arriendo = r.data.url_excel_arriendo
                //this.renderBarChart(r.data)
            })
            this.spinner_arriendo = false;
        },

        async desecho_por_periodo() {
            this.spinner_desecho = true;
            let body = {
                periodos: this.periodos_mensuales
            }
            await this.axios.post(`${this.api}/reporte/grafico/desecho_por_periodo`, body, this.cabeceras_json).then(r => {
                console.log('desecho por periodo', r.data)
                this.renderChartDesecho(r.data)
                //this.renderBarChart(r.data)
            })
            this.spinner_desecho = false;
        },

        async mortalidad_ensilaje_por_periodo() {
            this.spinner_mortalidad = true;
            let body = {
                periodos: this.periodos_mensuales
            }
            await this.axios.post(`${this.api}/reporte/grafico/mortalidad_ensilaje_por_periodo`, body, this.cabeceras_json).then(r => {
                console.log('desecho por periodo', r.data)
                this.renderChartMortalidadEnsilaje(r.data)
                //this.renderBarChart(r.data)
            })
            this.spinner_mortalidad = false;
        },

        renderChartCamion(data) {
            // if (this.chart_detalle_camion) {
            //     this.chart_detalle_camion.destroy()
            // }
            // this.chart_detalle_camion = new Chart(document.getElementById("grafico_detalle_camion"), {
            //     type: 'line',
            //     data: {
            //         labels: data.labels,
            //         datasets: [
            //             {
            //                 label: 'Recorrido Teórico (Km)',
            //                 data: data.km_teorico,
            //                 borderColor: '#ff8500',
            //                 backgroundColor: '#ff8500',
            //             },
            //             {
            //                 label: 'Recorrido Real (Km)',
            //                 data: data.km_real,
            //                 borderColor: '#38b000',
            //                 backgroundColor: '#38b000',
            //             },
            //             {
            //                 label: 'Petróleo Consumido (Lts)',
            //                 data: data.litros,
            //                 borderColor: '#1d3557',
            //                 backgroundColor: '#1d3557',
            //             },
            //             {
            //                 label: 'Rendimiento (Prom.)',
            //                 data: data.rendimiento,
            //                 borderColor: '#168aad',
            //                 backgroundColor: '#168aad',
            //             }
                        
            //         ]
            //     },
            //     options: {
            //         scales: {
            //             y: {
            //                 beginAtZero: true
            //             }
            //         },
            //         plugins: {
            //             title: {
            //                 display: true,
            //                 text: 'GRÁFICO DE CAMIÓN PATENTE '+data.patente
            //             }
            //         }
            //     }
            // });
            if (this.chart_detalle_kilometraje) {
                this.chart_detalle_kilometraje.destroy()
            }
            //Empezamos con nuevo gráfico separado de "grafico_kilometrajes"
            this.chart_detalle_kilometraje = new Chart(document.getElementById("grafico_kilometrajes"), {
                type: 'bar',
                data: {
                    labels: data.grafico_kilometraje.labels,
                    datasets: [
                        {
                            label: 'Recorrido Teórico (Km)',
                            data: data.grafico_kilometraje.kilometros_teoricos,
                            borderColor: '#ff8500',
                            backgroundColor: '#ff8500',
                        },
                        {
                            label: 'Recorrido Real (Km)',
                            data: data.grafico_kilometraje.kilometros_reales,
                            borderColor: '#38b000',
                            backgroundColor: '#38b000',
                        },
                    ]
                },
                options: {
                    scales: {
                        y: {
                            beginAtZero: true
                        }
                    },
                    plugins: {
                        title: {
                            display: true,
                            text: 'GRÁFICO DE CAMIÓN PATENTE '+data.patente+' DE KILOMETRAJE REAL/TEORICO'
                        }
                    }
                }
            });
            if (this.chart_detalle_rendimiento) {
                this.chart_detalle_rendimiento.destroy()
            }
            //Empezamos con nuevo gráfico separado de "grafico_kilometrajes"
            this.chart_detalle_rendimiento = new Chart(document.getElementById("grafico_rendimiento"), {
                type: 'line',
                data: {
                    labels: data.grafico_rendimiento.labels,
                    datasets: [
                        {
                            label: 'Rendimiento Promedio',
                            data: data.grafico_rendimiento.rendimiento_promedio,
                            borderColor: '#168aad',
                            backgroundColor: '#168aad',
                        },
                        {
                            label: 'Rendimiento Óptimo',
                            data: data.grafico_rendimiento.rendimiento_optimo,
                            borderColor: '#57cc99',
                            backgroundColor: '#57cc99',
                        }
                    ]
                },
                options: {
                    scales: {
                        y: {
                            beginAtZero: true
                        }
                    },
                    plugins: {
                        title: {
                            display: true,
                            text: 'GRÁFICO DE CAMIÓN PATENTE '+data.patente+' DE RENDIMIENTO'
                        }
                    }
                }
            });
            if (this.chart_detalle_petroleo) {
                this.chart_detalle_petroleo.destroy()
            }
            //Empezamos con nuevo gráfico separado de "grafico_kilometrajes"
            this.chart_detalle_petroleo = new Chart(document.getElementById("grafico_petroleo"), {
                type: 'bar',
                data: {
                    labels: data.grafico_petroleo.labels,
                    datasets: [
                        {
                            label: 'Petróleo Consumido (vueltas) (Lts)',
                            data: data.grafico_petroleo.litros_consumidos,
                            borderColor: '#1d3557',
                            backgroundColor: '#1d3557',
                        },
                        {
                            label: 'Petróleo Cargado (Lts)',
                            data: data.grafico_petroleo.litros_cargados,
                            borderColor: '#00b4d8',
                            backgroundColor: '#00b4d8',
                        },
                    ]
                },
                options: {
                    scales: {
                        y: {
                            beginAtZero: true
                        }
                    },
                    plugins: {
                        title: {
                            display: true,
                            text: 'GRÁFICO DE CAMIÓN PATENTE '+data.patente+' DE PETROLEO CONSUMIDO'
                        }
                    }
                }
            });
        },
        renderBarChartPetroleo(data) {
            if (this.bar_chart_petroleo) {
                this.bar_chart_petroleo.destroy()
            }
            this.bar_chart_petroleo = new Chart(document.getElementById("petroleo_por_periodo"), {
                type: 'bar',
                data: {
                    labels: data.labels,
                    datasets: [
                        {
                            label: 'Petroleo Consumido',
                            data: data.consumidos,
                            borderColor: '#95d5b2',
                            backgroundColor: '#95d5b2',
                        },
                        {
                            label: 'Petroleo Cargado',
                            data: data.cargados,
                            borderColor: '#bbdefb',
                            backgroundColor: '#bbdefb',
                        }
                    ]
                },
                options: {
                    scales: {
                        y: {
                            beginAtZero: true
                        }
                    },
                    plugins: {
                        title: {
                            display: true,
                            text: 'GRÁFICO DE CONSUMO Y CARGA DE PETRÓLEO POR PERIODO (LITROS)'
                        }
                    }
                }
            });
        },
        renderBarChartArriendo(data) {
            if (this.bar_chart_arriendo) {
                this.bar_chart_arriendo.destroy()
            }
            this.bar_chart_arriendo = new Chart(document.getElementById("arriendo_por_periodo"), {
                type: 'bar',
                data: {
                    labels: data.labels,
                    datasets: [
                        {
                            type: 'bar',
                            label: 'Total Arriendo',
                            data: data.total_arriendo,
                            borderColor: '#bbdefb',
                            backgroundColor: '#bbdefb',
                        },
                        {
                            type: 'bar',
                            label: 'Total Días Trabajados',
                            data: data.total_trabajado,
                            borderColor: '#95d5b2',
                            backgroundColor: '#95d5b2',
                        },
                        {
                            type: 'bar',
                            label: 'Total Días No Trabajados',
                            data: data.total_no_trabajado,
                            borderColor: '#ff686b',
                            backgroundColor: '#ff686b',
                        },

                    ]
                },
                options: {
                    scales: {
                        y: {
                            beginAtZero: true
                        }
                    },
                    plugins: {
                        title: {
                            display: true,
                            text: 'GRÁFICO GASTO ARRIENDO DE CAMIONES POR PERIODO (PESOS)'
                        }
                    }
                    //indexAxis:'y'
                },

            });
        },

        renderChartDesecho(data) {
            if (this.chart_desecho) {
                this.chart_desecho.destroy()
            }
            this.chart_desecho = new Chart(document.getElementById("desecho_por_periodo"), {
                type: 'bar',
                data: {
                    labels: data.labels,
                    datasets: [
                        {
                            type: 'bar',
                            label: 'Total',
                            data: data.total,
                            borderColor: '#02c39a',
                            backgroundColor: '#02c39a',
                        },
                        {
                            type: 'bar',
                            label: 'Planta Harina y Aceite',
                            data: data.total_harina_aceite,
                            borderColor: '#ffcdb2',
                            backgroundColor: '#ffcdb2',
                        },
                        {
                            type: 'bar',
                            label: 'Planta Ensilaje',
                            data: data.total_ensilaje,
                            borderColor: '#d8e2dc',
                            backgroundColor: '#d8e2dc',
                        },
                        {
                            type: 'bar',
                            label: 'Vertedero',
                            data: data.total_vertedero,
                            borderColor: '#6d6875',
                            backgroundColor: '#6d6875',
                        },

                    ]
                },
                options: {
                    scales: {
                        y: {
                            beginAtZero: true
                        }
                    },
                    plugins: {
                        title: {
                            display: true,
                            text: 'GRÁFICO RECEPCIÓN DE SUBPRODUCTO (KG)'
                        },
                        tooltip: {
                            callbacks: {
                                footer: (tooltipItems) => {
                                    let sum = 0;

                                    tooltipItems.forEach(function (tooltipItem) {
                                        sum += tooltipItem.parsed.y;
                                    });
                                    return 'Toneladas: ' + this.$options.filters.formatear_miles2(Math.round(sum / 1000));
                                }
                            }
                        }
                    }
                    //indexAxis:'y'
                },

            });
        },

        renderChartMortalidadEnsilaje(data) {
            if (this.chart_mortalidad_ensilaje) {
                this.chart_mortalidad_ensilaje.destroy()
            }
            this.chart_mortalidad_ensilaje = new Chart(document.getElementById("mortalidad_ensilaje_por_periodo"), {
                type: 'bar',
                data: {
                    labels: data.labels,
                    datasets: [
                        {
                            type: 'bar',
                            label: 'Total',
                            data: data.total,
                            borderColor: '#81b29a',
                            backgroundColor: '#81b29a',
                        },
                        {
                            type: 'bar',
                            label: 'Ensilaje',
                            data: data.total_ensilaje,
                            borderColor: '#b56576',
                            backgroundColor: '#b56576',
                        },
                        {
                            type: 'bar',
                            label: 'Mortalidad',
                            data: data.total_mortalidad,
                            borderColor: '#f4978e',
                            backgroundColor: '#f4978e',
                        },

                    ]
                },
                options: {
                    scales: {
                        y: {
                            beginAtZero: true
                        }
                    },
                    plugins: {
                        title: {
                            display: true,
                            text: 'GRÁFICO RECEPCIÓN DE MORTALIDAD/ENSILAJE (KG)'
                        }
                    }
                    //indexAxis:'y'
                },

            });
        },

        async cargar_camiones_arrendados() {
            await this.axios.get(`${this.api}/reporte/grafico/camiones/arrendados`, this.cabeceras_json).then(r => {
                this.camiones_arrendados = r.data
            })
        },

        async cargar_camiones_petroleo() {
            await this.axios.get(`${this.api}/reporte/grafico/camiones/petroleo`, this.cabeceras_json).then(r => {
                this.camiones_petroleo = r.data
            })
        },

        async cargar() {
            this.axios.get(`${this.api}/reporte/arriendo/camiones/${this.fecha}`, this.cabeceras_json).then(r => {
                this.data = r.data.data
                console.log('data', r.data)
            })
        },
        descargar_excel_arriendo() {
            if (this.url_excel_arriendo) {
                window.open(this.url_excel_arriendo, "_blank");
            }
        }
    },
    computed: {
        ...mapState(['api', 'cabeceras_json'])
    }

}
</script>
<style>
.tableFixHead {
    overflow: auto;
    height: 600px;
}

.tableFixHead thead th {
    position: sticky;
    top: 0;
    z-index: 1;
}

.selected-button {
  background-color: white !important;
  color: blue !important;
}

/* Just common table stuff. Really. */
table {
    border-collapse: collapse;
    width: 100%;
}

th,
td {
    padding: 8px 16px;
}

th {
    background: #427391;
    color: #fff
}
</style>